import type { QuotaCheckResponseDto, StreamResponseDto } from '@/services/types';

import type { QuotaCheck, VideoStream } from './types';

export function mapStreamResponseToDomain(response: StreamResponseDto): VideoStream {
    return {
        id: response.id,
        playbackId: response.playbackId,
    };
}

export function mapQuotaCheckResponseToDomain(response: QuotaCheckResponseDto): QuotaCheck {
    return {
        status: response.status,
    };
}
